import dynamic from 'next/dynamic';
import React from 'react';

const HomescreenPage = dynamic(() => import('@members/pg-homescreen/HomescreenPage'), {
  ssr: false,
});

export default function Homescreen() {
  return <HomescreenPage />;
}
